export default "__VITE_ASSET__DK3srgoP__"